export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adjuntos"])},
          "no_attachments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No hay adjuntos"])}
        }
      },
      "en": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attachments"])},
          "no_attachments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No attachments"])}
        }
      }
    }
  })
}